export default{
  appStart: {
    'Userloggedin': 1000100,
    'Userloggedout': 1000101,
    'Usernavigatefeedback': 1000102,
    'Usernavigatedanalytic': 1000103,
    'Usernavigatedpushnotifications': 1000104,
    'Usernavigatedtoaccount': 1000110,
    'Userchangedaccountemail': 1000111,
    'Userchangedpassword': 1000112,
    'UserdeletedONAIRaccount': 1000113,
    'Usersentpushnotification': 1000120,
    'Usercreatednewapp': 1000200,
    'Userdeletedapp': 1000201,
    'Useractivatedanotherapp': 1000202,
    'Userinvitedanotherperson': 1000203
  },
  appModule:
  {
    'Useraddedmodule': 1000300,
    'Userdeletedmodule': 1000301,
    'Usercreatednewpost': 1000302,
    'Userdeletedpost': 1000303,
    'Useractivatedlikefunction': 1000304,
    'Userdisabledlikefunction': 1000305,
    'Useractivatedcommentfunction': 1000306,
    'Userdisabledcommentfunction': 1000307,
    'Useractivatedsharefunction': 1000308,
    'Userdisabledsharefunction': 1000309,
    'Useraddedcategory': 1000310,
    'Userdeletedcategory': 1000311,
    'Useraddedphotoalbum': 1000312,
    'Userdeletedphotoalbum': 1000313,
    'Useraddedmultiplephotos': 1000314,
    'Userdeletedphoto': 1000315,
    'Useraddedpersonteam': 1000316,
    'Userdeletedpersonteam': 1000317
  },
  appContent: {
    'Useraddedtitle': 1000400,
    'Userdeletetitle': 1000401,
    'Useraddedtext': 1000402,
    'Userdeletedtext': 1000403,
    'Useraddedimage': 1000404,
    'Userdeletedimage': 1000405,
    'Useraddedimageslider': 1000406,
    'Userdeletedimageslider': 1000407,
    'Useraddedvideo': 1000408,
    'Userdeletedvideo': 1000409,
    'Useraddedbutton': 1000410,
    'Userdeletedbutton': 1000411,
    'Useraddedlink': 1000412,
    'Userdeletedlink': 1000413,
    'Useraddedmap': 1000414,
    'Userdeletedmap': 1000415,
    'Useraddedhighlightbox': 1000416,
    'Userdeletedhighlightbox': 1000417,
    'Useradddedaccordeon': 1000418,
    'Userdeletedaccordeon': 1000419,
    'Useraddedtab': 1000420,
    'Userdeletedtab': 1000421,
    'Useraddedmediacard': 1000422,
    'Userdeletedmediacard': 1000423,
    'Useraddedlist': 1000424,
    'Userdeletedlist': 1000425,
    'Useraddedtable': 1000426,
    'Userdeletedtable': 1000427,
    'Useraddedline': 1000428,
    'Userdeletedline': 1000429,
    'Useraddedspacer': 1000430,
    'Userdeletedspacer': 1000431,
    'Useraddedtextinputform': 1000450,
    'Userdeletedtextinputform': 1000451,
    'Useraddedselectionform': 1000452,
    'Userdeletedselectionform': 1000453,
    'Useraddednumberinputform': 1000454,
    'Userdeletednumberinputform': 1000455,
    'Useraddedselectionviewform': 1000456,
    'Userdeletedselectionviewform': 1000457,
    'Useraddedspineditform': 1000458,
    'Userdeletedspineditform': 1000459,
    'Useraddedcheckboxform': 1000460,
    'Userdeletedcheckboxform': 1000461,
    'Useraddedemailphoneurlform': 1000462,
    'Userdeletedemailphoneurlform': 1000463,
    'Useraddedradioboxform': 1000464,
    'Userdeletedradioboxform': 1000465,
    'Useraddedadateeditform ': 1000466,
    'Userdeleteddateeditform': 1000467,
    'Useraddedcalendarform': 1000468,
    'Userdeletedcalendarform': 1000469,
    'Useraddedtimeeditform': 1000470,
    'Userdeletedtimeeditform': 1000471,
    'Useraddedratingform': 1000472,
    'Userdeletedratingform': 1000473,
    'Useraddedmemoform': 1000474,
    'Userdeletedmemoform': 1000475,
    'Useraddedsatisfactionform': 1000476,
    'Userdeletedsatisfactionform': 1000477,
    'Useraddedswitchform': 1000478,
    'Userdeletedswitchform': 1000479,
    'Useraddedsliderform': 1000480,
    'Userdeletedsliderform': 1000481,
    'Userchangedthemecolor': 1000500,
    'Userchangedbackgroundcolor': 1000501,
    'Userchangedbackgroundpattern': 1000502,
    'Userchangeddefaultfont': 1000503
  },
  mainMenu: {
    'Userchangedlayout': 1000504,
    'Userswitchedapptofullscreen': 1000505,
    'Userswitchedappstarttocustom': 1000506,
    'Userchangedicon': 1000507,
    'Userchangedlabel': 1000508,
    'Userchangedbackgroundcolor': 1000509,
    'Userchangedorderitems': 1000510,
    'Userchangedfontface': 1000511},
  publish: {
    'Usernavigatedpublishsection': 1000600,
    'UserenabledAndroidpublishing': 1000601,
    'UserdisabledAndroidpublishing': 1000602,
    'UserenablediOSpublishing': 1000603,
    'UserdisablediOSpublishing': 1000604,
    'Userchangedappid': 1000605,
    'Userchangedappname': 1000606,
    'Userincreasedappversion': 1000607,
    'Userselectedappicon': 1000608,
    'Useruploadedcustomappicon': 1000609,
    'Userselectedsplashscreen': 1000610,
    'Useruploadedcustomsplashscreen': 1000611,
    'UserdownloadiOSdistcertificate': 1000612,
    'UseruploadediOSdistcertificate': 1000613,
    'UserdownloadedAPNScertificate': 1000614,
    'UseruploadedAPNScertificate': 1000615,
    'UseruploadedProvisionProfile': 1000616,
    'Userstartpublishingprocess': 1000617,
    'UserdownloadedwebQRcode': 1000618,
    'UserdownloadedAPKfile': 1000619,
    'UserdownloadedIPAfile': 1000620,
    'Userrestartedpublishing': 1000621
  },
  orderprocess: {
    'Userstartedapporder': 1000700,
    'Userstartedupgradeorder': 1000701,
    'UserstartedPLUSpackage': 1000702,
    'Userstarteddesignservice': 1000703,
    'Userstartedpublishingservice': 1000704,
    'Userstartedpushnotification': 1000705,
    'Userstartedsingleappupdate': 1000706,
    'Userfinishedapporder': 1000707,
    'Userfinishedappupgrade': 1000708,
    'UserfinishedPLUSpackage': 1000709,
    'Userfinisheddesignservice': 1000710,
    'Userfinishedpublishing': 1000711,
    'Userfinishedpushnotification': 1000712,
    'Userfinishedsingleappupdate': 1000713
  }
}



// WEBPACK FOOTER //
// ./src/activityConfig.js